module.exports = __webpack_public_path__ + "static/media/bg-scholarship.d446cb0e.jpg";